"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alpha = alpha;
exports.darken = darken;
exports.lighten = lighten;
exports.blend = blend;
exports.getLuminance = getLuminance;
const core = __importStar(require("./core"));
const {
  getRed,
  getGreen,
  getBlue,
  getAlpha,
  setAlpha,
  newColor
} = core;
/**
 * Modifies color alpha channel.
 * @param color - Color
 * @param value - Value in the range [0, 1]
 */
function alpha(color, value) {
  return setAlpha(color, Math.round(value * 255));
}
/**
 * Darkens a color.
 * @param color - Color
 * @param coefficient - Multiplier in the range [0, 1]
 */
function darken(color, coefficient) {
  const r = getRed(color);
  const g = getGreen(color);
  const b = getBlue(color);
  const a = getAlpha(color);
  const factor = 1 - coefficient;
  return newColor(r * factor, g * factor, b * factor, a);
}
/**
 * Lighten a color.
 * @param color - Color
 * @param coefficient - Multiplier in the range [0, 1]
 */
function lighten(color, coefficient) {
  const r = getRed(color);
  const g = getGreen(color);
  const b = getBlue(color);
  const a = getAlpha(color);
  return newColor(r + (255 - r) * coefficient, g + (255 - g) * coefficient, b + (255 - b) * coefficient, a);
}
/**
 * Blend (aka mix) two colors together.
 * @param background The background color
 * @param overlay The overlay color that is affected by @opacity
 * @param opacity Opacity (alpha) for @overlay
 * @param [gamma=1.0] Gamma correction coefficient. `1.0` to match browser behavior, `2.2` for gamma-corrected blending.
 */
function blend(background, overlay, opacity, gamma = 1.0) {
  const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
  const r = blendChannel(getRed(background), getRed(overlay));
  const g = blendChannel(getGreen(background), getGreen(overlay));
  const b = blendChannel(getBlue(background), getBlue(overlay));
  return newColor(r, g, b, 255);
}
/**
 * The relative brightness of any point in a color space, normalized to 0 for
 * darkest black and 1 for lightest white.
 * @returns The relative brightness of the color in the range 0 - 1, with 3 digits precision
 */
function getLuminance(color) {
  const r = getRed(color) / 255;
  const g = getGreen(color) / 255;
  const b = getBlue(color) / 255;
  const apply = v => v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  const r1 = apply(r);
  const g1 = apply(g);
  const b1 = apply(b);
  return Math.round((0.2126 * r1 + 0.7152 * g1 + 0.0722 * b1) * 1000) / 1000;
}
